import { useCallback, useEffect, useRef } from 'react';

const useMapCenterHelper = (location) => {
  const mapRef = useRef(null);

  const handleMap = useCallback((m) => (mapRef.current = m), []);

  useEffect(() => {
    if (mapRef.current) {
      if (location.bounds) {
        console.log('Location bounds changed: ', location, mapRef.current);
        const { latMin, lngMin, latMax, lngMax } = location.bounds;
        mapRef.current.flyToBounds([
          [latMin, lngMin],
          [latMax, lngMax],
        ]);
      } else {
        console.log('Location center changed: ', location, mapRef.current);
        mapRef.current.flyTo(location);
      }
    }
  }, [location]);

  return handleMap;
};

export default useMapCenterHelper;
